<template>
  <validation-observer ref="summary">
    <div class="form-container row mx-md-0">
      <div class="col-12 col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.period"
            class="dropdown"
            custom-error-msg="Favor seleccione el periodo académico."
            :error="errors[0]"
            fieldkey="periodId"
            fieldname="name"
            label="Periodo Académico:"
            :options="executionFormOptions.period"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.executionLevel"
            class="dropdown"
            :clearable="false"
            custom-error-msg="Favor seleccione el nivel de ejecución."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Clave de Objetivo:"
            :options="executionFormOptions.executionLevels"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md-3 form-container__actions">
        <action-button
          i="fas fa-times-circle"
          :responsive="false"
          variant="outline-danger mr-2 cancel-btn"
          @click="cancel"
        />

        <action-button
          i="fa fa-save"
          :responsive="false"
          variant="outline-success ok-btn"
          @click="save"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'ExecutionLevelForm',
  components: {
    ActionButton,
    CustomDropDown,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    executionFormOptions: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      executionLevel: null,
      period: null,
    },
  }),
  watch: {
    data: {
      immediate: true,
      handler(current) {
        if (current) {
          this.executionLevel = { ...current };
        }
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel-legend');
    },
    async save() {
      const isValid = await this.$refs.summary.validate();
      if (!isValid) {
        return;
      }
      this.$emit('save-legend', this.model);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  .period-chip {
    border-radius: 0.9rem;
    color: white;
    padding: 0.2rem 0.5rem;
  }

  ::v-deep &__actions {
    padding-top: 2rem;
    i {
      margin-right: 0px !important;
    }
  }
  @media only screen and (max-width: 768px) {
    .col-12 {
      margin-top: 1rem;
    }
    &__actions {
      padding-top: 0;
      display: flex;
      justify-content: space-between;
      .ok-btn,
      .cancel-btn {
        width: 50%;
      }
    }
  }
}
</style>
